/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .progress-stepper {
    display: flex;
    flex-direction: column;
    padding: 16px;
  }

  .progress-step {
    display: flex;
    gap: 12px;
    align-items: flex-start;

    .progress-step-indicator {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      width: 24px;
    }

    .progress-step-dot {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      flex-shrink: 0;
      border: 2px solid ${$.gray300};
      background: ${$.white};
      color: ${$.gray500};
      transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
    }

    .progress-step-line {
      width: 2px;
      flex: 1;
      min-height: 14px;
      background: ${$.gray200};
      margin: 3px 0 0;
      transition: background 0.2s;
    }

    .progress-step-label {
      font-size: 13px;
      color: ${$.gray500};
      line-height: 1.4;
      padding: 3px 0 18px;
    }

    &.complete_state {
      .progress-step-dot {
        background: ${$.successMain};
        border-color: ${$.successMain};
        color: ${$.white};
      }

      .progress-step-line {
        background: ${$.successMain};
      }

      .progress-step-label {
        color: ${$.gray700};
      }

      &.is-last-state {
        .progress-step-dot {
          background: ${$.successMain};
          border-color: ${$.successMain};
          box-shadow: 0 0 0 4px ${$.successMain}33;
        }

        .progress-step-label {
          font-weight: 600;
          color: ${$.successMain};
        }
      }
    }

    &.current_state {
      .progress-step-dot {
        background: ${$.primaryMain};
        border-color: ${$.primaryMain};
        color: ${$.white};
        box-shadow: 0 0 0 4px ${$.primaryMain}33;
      }

      .progress-step-label {
        font-weight: 600;
        color: ${$.primaryMain};
      }
    }

    &.next_state {
      .progress-step-dot {
        background: ${$.white};
        border-color: ${$.gray300};
        color: transparent;
      }
    }
  }
`;
